import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { RecallSearchSettingsContainer_OptimizedV2State } from "@/Communications/Components/Search/RecallSearchSettingsContainer_OptimizedV2";

class RecallSearchSettings {
    public IsAllSitesChecked: boolean;
    public IsAllCliniciansChecked: boolean;
    public IsDeactivatedChecked: boolean;
    public IsAllPriorityChecked: boolean;
    public IsAllStatusChecked: boolean;
    public SiteIds: string[];
    public ClinicianIds: string[];
    public Priorities: string[];
    public Status: string[];
    public PageSize: number;
    public OrderByPriorityFirst: boolean;

    public static FromModel(model: RecallSearchSettingsContainer_OptimizedV2State): RecallSearchSettings {
        let helper = new MyleHelper();

        let display: RecallSearchSettings = new RecallSearchSettings();
        display.IsAllSitesChecked = model.isAllSitesChecked;
        display.IsAllCliniciansChecked = model.isAllCliniciansChecked;
        display.IsDeactivatedChecked = model.isAllDeactivatedCliniciansChecked;
        display.IsAllPriorityChecked = model.isAllPrioritiesChecked;
        display.IsAllStatusChecked = model.isAllStatusChecked;
        display.SiteIds = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.sites)).map(x => x.Id).toArray();
        display.ClinicianIds = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.clinicians)).map(x => x.Id).toArray();
        display.Priorities = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.priorities)).map(x => x.Id).toArray();
        display.Status = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.statuses)).map(x => x.Id).toArray();
        display.PageSize = model.selectedPageSizeOption;
        display.OrderByPriorityFirst = model.orderByPriorityFirst;
        return display;
    }
}

export { RecallSearchSettings };
